import createReducer from "./createReducer";
import { SUPPRESS_SUCCESS_GROWL } from "utils/constants";
import { RESET_CONTENT_FEED_DECISIONING_MODAL } from "reducers/ContentFeedDecisioning";

const initialState = {
	page: 0,
	pages: 0,
	total: 0,
	data: [],
	isLoading: false,
	hasErrorLoading: false,
};

const CONTENT_FEED_DETAILS_ACTIONS = {
	FETCH_CONTENT_FEED_DETAILS_AJAX: "FETCH_CONTENT_FEED_DETAILS_AJAX",
	FETCH_CONTENT_FEED_DETAILS_SUCCESS: "FETCH_CONTENT_FEED_DETAILS_SUCCESS",
	FETCH_CONTENT_FEED_DETAILS_ERROR: "FETCH_CONTENT_FEED_DETAILS_ERROR",

	RESET_CONTENT_FEED_DETAILS: "RESET_CONTENT_FEED_DETAILS",
};

export const handlers = {
	[CONTENT_FEED_DETAILS_ACTIONS.FETCH_CONTENT_FEED_DETAILS_AJAX]: fetchContentFeedDetails,
	[CONTENT_FEED_DETAILS_ACTIONS.FETCH_CONTENT_FEED_DETAILS_SUCCESS]: fetchContentDetailsSuccess,
	[CONTENT_FEED_DETAILS_ACTIONS.FETCH_CONTENT_FEED_DETAILS_ERROR]: fetchContentDetailsError,

	[CONTENT_FEED_DETAILS_ACTIONS.RESET_CONTENT_FEED_DETAILS]: resetContentFeedDetails,
	[RESET_CONTENT_FEED_DECISIONING_MODAL]: resetContentFeedDetails,
};

let reducerConfig = {
	typeRoot: "CONTENT_FEED_DETAILS",
	actionTypes: CONTENT_FEED_DETAILS_ACTIONS,
	actionCreators: {
		loadContentFeedDetails,
		clearContentFeedDetails,
	},
	initialState,
	handlers,
};

export function loadContentFeedDetails(feedId, params = {}) {
	return (dispatch) => {
		return dispatch({
			type: CONTENT_FEED_DETAILS_ACTIONS.FETCH_CONTENT_FEED_DETAILS_AJAX,
			meta: SUPPRESS_SUCCESS_GROWL,
			AJAX: {
				params,
				gateway: "cfa",
				version: 1,
				url: `feeds/${feedId}/versions`,
				method: "get",
				success: CONTENT_FEED_DETAILS_ACTIONS.FETCH_CONTENT_FEED_DETAILS_SUCCESS,
				error: CONTENT_FEED_DETAILS_ACTIONS.FETCH_CONTENT_FEED_DETAILS_ERROR,
			},
		});
	};
}

export function clearContentFeedDetails() {
	return (dispatch) => {
		dispatch({
			type: CONTENT_FEED_DETAILS_ACTIONS.RESET_CONTENT_FEED_DETAILS,
		});

		return Promise.resolve({ success: true });
	};
}

function fetchContentFeedDetails(state, action) {
	return {
		...state,
		data: [],
		isLoading: true,
		hasErrorLoading: false,
	};
}

function fetchContentDetailsSuccess(state, action) {
	const { data, pages, total } = action.payload;

	return {
		...state,
		data,
		pages,
		total,
		isLoading: false,
		hasErrorLoading: false,
	};
}

function fetchContentDetailsError(state, action) {
	return {
		...state,
		isLoading: false,
		hasErrorLoading: true,
	};
}

function resetContentFeedDetails(state, action) {
	return {
		...initialState,
	};
}

export default createReducer(reducerConfig.initialState, reducerConfig.handlers);
